import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.isMobile
    ? _c(_setup.InfoLayout, {
        attrs: {
          "current-path": _setup.reverseFull({ name: "legal_case" }),
          "is-policy": false,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " +
                      _vm._s(_setup.t("Битва за отзывы", _setup.options)) +
                      "\n  "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "container" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex mb-sm-4 my-4 my-sm-0" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "text-decoration-none",
                              attrs: {
                                href: `${_setup.reverseFull({
                                  name: "legal_case",
                                })}?page=${_setup.context.case_page}#${
                                  _setup.context.legal_case.id
                                }`,
                              },
                            },
                            [
                              _c(
                                VIcon,
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "primary" },
                                },
                                [
                                  _vm._v(
                                    "\n            ui-icon-arrow-back\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "primary--text legal-case__link-text",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _setup.t("к списку", _setup.options)
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(_setup.LegalCaseCard, {
                        staticClass: "mb-6",
                        attrs: {
                          "legal-case": _setup.context.legal_case,
                          "is-legal-case-item-page": "",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-sm-end justify-space-between mb-4 text--primary",
                        },
                        [
                          _setup.context.previous_case.id
                            ? _c(
                                "a",
                                {
                                  staticClass: "text-decoration-none mr-6",
                                  attrs: {
                                    href: _setup.reverseFull({
                                      name: "legal_case_page",
                                      args: [_setup.context.previous_case.id],
                                    }),
                                  },
                                },
                                [
                                  _c(
                                    VIcon,
                                    {
                                      staticClass: "ml-2",
                                      attrs: { color: "primary" },
                                    },
                                    [
                                      _vm._v(
                                        "\n            ui-icon-arrow-left\n          "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "primary--text legal-case__link-text",
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _setup.t(
                                              "предыдущее",
                                              _setup.options
                                            )
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "text-decoration-none",
                              class: {
                                "mx-auto": !_setup.context.previous_case.id,
                              },
                              attrs: {
                                href: _setup.reverseFull({
                                  name: "legal_case_page",
                                  args: [_setup.context.next_case.id],
                                }),
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "primary--text legal-case__link-text",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _setup.t("следующее", _setup.options)
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                VIcon,
                                {
                                  staticClass: "ml-2",
                                  attrs: { color: "primary" },
                                },
                                [
                                  _vm._v(
                                    "\n            ui-icon-arrow-right\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2336115892
        ),
      })
    : _c(
        "div",
        { staticClass: "container" },
        [
          _c("div", { staticClass: "d-flex mb-sm-4 my-4 my-sm-0" }, [
            _c(
              "a",
              {
                staticClass: "text-decoration-none",
                attrs: {
                  href: `${_setup.reverseFull({ name: "legal_case" })}?page=${
                    _setup.context.case_page
                  }#${_setup.context.legal_case.id}`,
                },
              },
              [
                _c(
                  VIcon,
                  { staticClass: "mr-2", attrs: { color: "primary" } },
                  [_vm._v("\n        ui-icon-arrow-back\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "primary--text legal-case__link-text" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.t("к списку", _setup.options)) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(_setup.LegalCaseCard, {
            staticClass: "mb-6",
            attrs: {
              "legal-case": _setup.context.legal_case,
              "is-legal-case-item-page": "",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-sm-end justify-space-between mb-4 text--primary",
            },
            [
              _setup.context.previous_case.id
                ? _c(
                    "a",
                    {
                      staticClass: "text-decoration-none mr-6",
                      attrs: {
                        href: _setup.reverseFull({
                          name: "legal_case_page",
                          args: [_setup.context.previous_case.id],
                        }),
                      },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "ml-2", attrs: { color: "primary" } },
                        [_vm._v("\n        ui-icon-arrow-left\n      ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "primary--text legal-case__link-text" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.t("предыдущее", _setup.options)) +
                              "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "text-decoration-none",
                  class: { "mx-auto": !_setup.context.previous_case.id },
                  attrs: {
                    href: _setup.reverseFull({
                      name: "legal_case_page",
                      args: [_setup.context.next_case.id],
                    }),
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "primary--text legal-case__link-text" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.t("следующее", _setup.options)) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    VIcon,
                    { staticClass: "ml-2", attrs: { color: "primary" } },
                    [_vm._v("\n        ui-icon-arrow-right\n      ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }